import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { OtcOrder } from "../types/cryptoSwaps.types";
import { isNonTerminalStatus } from "../utils/cryptoSwapStatus";
import { useOtcOrderPoller, type UseOtcOrderResult } from "./useOtcOrderPoller";

export type UseCryptoSwapOrderResult = UseOtcOrderResult<OtcOrder>;

const fetchOrder = (orderId: string) => CryptoSwapsService.getOrder(orderId);
const isLiveOrder = (order: OtcOrder) => isNonTerminalStatus(order.status);

/** One purchase, polled while the USDT is on its way. */
export function useCryptoSwapOrder(orderId: string | null): UseCryptoSwapOrderResult {
  return useOtcOrderPoller(orderId, fetchOrder, isLiveOrder);
}
